import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { UsersService } from 'src/app/users/users.service';
import { DeviceManagementService } from '../device-management.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { DeviceFactory } from 'src/app/home/site-dashboard/device/device-factory/device-factory';

@Component({
	selector: 'app-reverse-rt',
	templateUrl: './reverse-rt.component.html',
})
export class ReverseRtComponent implements OnInit {

	@Input() device: any = {};
	@Input() currentSite: any = {};

	startId;
	endId;
	isIMDevice = false;

	constructor(
		private deviceManagementService: DeviceManagementService,
		private notificationMessage: NotificationMessageService,
		private usersService: UsersService,
		private router: Router,
		private translate: TranslateService,
		private commonService: CommonService,
	){}

	ngOnInit() {
		if(!this.usersService.hasAccessFunction('device_management'))
			return this.router.navigate(['/unauthorized']);

		this.isIMDevice = DeviceFactory.isIMDeviceType(this.device.config_info.sct_device_type);

		this.commonService.setPageTabTitle(`${this.currentSite.customer_name} - ${this.currentSite.name} - ${this.device.serial_number} - ${this.translate.instant('action_log.reverse_rt')}`);
	}

	reverseRT() {
		if(!this.startId || !this.endId || this.startId > this.endId)
			return this.notificationMessage.setMessage('translate|g.invalid_input', {clearOnXTimeNavigate: 1});
		this.deviceManagementService.reverseRT(this.device.mac_address, this.startId, this.endId).subscribe(()=>{
			this.startId = this.endId = null;
			this.notificationMessage.setMessage('globalSuccessMsg',{clearOnXTimeNavigate: 1});
		});
	};
}
